import { render } from "./searchResults.vue?vue&type=template&id=012ece0b"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wojtek/web/customer-zone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__